// Small formatting helpers shared across pages.

export const fmtInt = (n: number): string => Math.round(n || 0).toLocaleString();

export const fmtMoney = (n: number): string => {
  const abs = Math.abs(n || 0);
  if (abs >= 1_000_000) return '$' + (n / 1_000_000).toFixed(2) + 'M';
  if (abs >= 1_000) return '$' + Math.round(n / 1_000) + 'K';
  return '$' + Math.round(n || 0).toLocaleString();
};

export const fmtMinutes = (n: number): string => {
  if ((n || 0) >= 1_000) return (n / 1_000).toFixed(1) + 'K';
  return String(Math.round(n || 0));
};

/** Tone bucket for a 0-100 score: green >=80, orange >=60, red below. */
export const tone = (pct: number): 'pos' | 'warn' | 'neg' =>
  pct >= 80 ? 'pos' : pct >= 60 ? 'warn' : 'neg';

export const initialsOf = (name: string): string => {
  const parts = (name || '?').trim().split(/\s+/).slice(0, 2);
  return parts.map((p) => p[0]?.toUpperCase() || '').join('') || '?';
};

export const codeOf = (id: string): string => (id || '???').slice(0, 3).toUpperCase();

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** '2026-06' -> 'Jun'. */
export const monthLabel = (key: string): string => {
  const m = Number.parseInt((key || '').split('-')[1] || '0', 10);
  return MONTHS[m - 1] || key;
};

/** Human "x days ago" for ISO date strings. */
export const timeAgo = (iso: string | null | undefined): string => {
  if (!iso) return '—';
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return '—';
  const days = Math.floor((Date.now() - then) / 86_400_000);
  if (days <= 0) return 'today';
  if (days === 1) return '1 day ago';
  if (days < 30) return `${days} days ago`;
  const months = Math.floor(days / 30);
  return months === 1 ? '1 month ago' : `${months} months ago`;
};

/** Clamp a possibly-out-of-range percent (some source rates exceed 100). */
export const clampPct = (n: number): number => Math.max(0, Math.min(100, Math.round(n || 0)));
